<template>
  <transition-group mode="out-in" name="fade-transform">
    <inner-link
      v-for="(item, index) in iframeViews"
      v-show="$route.path === item.path"
      :key="item.path + '_' + (item.meta._refreshKey || 0)"
      :iframeId="'iframe' + index"
      :src="iframeUrl(item.meta.link, item.query)"
    ></inner-link>
  </transition-group>
</template>

<script>
import InnerLink from "../InnerLink/index"

export default {
  components: { InnerLink },
  computed: {
    iframeViews() {
      return this.$store.state.tagsView.iframeViews
    }
  },
  methods: {
    iframeUrl(url, query) {
      if (!url) {
        return url
      }
      // meta.link 已带查询串（如 main_single_number）时，不要再拼一层 query，
      // 否则会出现 ...html?type=ALL&main_single_number=xxx?url=... 把单号页覆盖成默认列表
      if (url.indexOf('?') !== -1) {
        return url
      }
      const q = query || {}
      const keys = Object.keys(q)
      if (keys.length > 0) {
        const params = keys.map((key) => key + "=" + q[key]).join("&")
        return url + "?" + params
      }
      return url
    }
  }
}
</script>
